module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_j_albino.94583515.png";